import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage/LandingPage';
import TermsOfService from './pages/TermsOfService/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ContactForm from './pages/ContactForm/ContactForm';
import EmailConfirmation from './pages/EmailConfirmation/EmailConfirmation';
import PricingPlans from './pages/PricingPlans/PricingPlans';
import Pricing299 from './pages/Pricing299/Pricing299';
import Pricing799 from './pages/Pricing799/Pricing799';
import TrackOrder from './pages/TrackOrder/TrackOrder';
import AgentPanel from './pages/AgentPanel/AgentPanel';
import ChatWidget from './components/ChatWidget/ChatWidget';
import SamePageReloadHandler from './components/SamePageReloadHandler';
import VisitTracker from './components/VisitTracker';

/**
 * Главный компонент приложения
 * Использует React Router для навигации между страницами
 */
function App() {
  return (
    <Router>
      <div className="App">
        {/* Visit Tracker - отслеживает посещения страниц и отправляет уведомления в Telegram */}
        <VisitTracker />
        
        {/* Same Page Reload Handler - обрабатывает клики по ссылкам на ту же страницу */}
        <SamePageReloadHandler />
        
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-form" element={<ContactForm />} />
          <Route path="/email-confirmation" element={<EmailConfirmation />} />
          <Route path="/pricing-plans" element={<PricingPlans />} />
          <Route path="/pricing-299" element={<Pricing299 />} />
          <Route path="/pricing-799" element={<Pricing799 />} />
          <Route path="/track-the-order" element={<TrackOrder />} />
          <Route path="/support-agent" element={<AgentPanel />} />
        </Routes>
        
        {/* Chat Widget - доступен на всех страницах кроме панели агента */}
        <ChatWidget />
      </div>
    </Router>
  );
}

export default App;
